import React from "react";
import "./CreateReservationSummary.css";
import {
  Card,
  BlockStack,
  Text,
  Divider,
  InlineGrid,
  Button,
  TextField,
} from "@shopify/polaris";

import { EditIcon } from "@shopify/polaris-icons";

import { getReservationTime } from "../../utility/ReservationUtilities";
import { formatDate, formatPrice } from "../../utility/funcs";

function CreateReservationSummary({
  details,
  editTotal,
  deliveryType,
  deliveryFee,
  onDeliveryFeeChange,
  returnType,
  returnFee,
  onReturnFeeChange,
}) {
  const time = getReservationTime(
    details.fromDate,
    details.fromHours,
    details.toDate,
    details.toHours
  );

  const totalDeliveryFees =
    (deliveryType === "delivery" ? parseFloat(deliveryFee) || 0 : 0) +
    (returnType === "delivery" ? parseFloat(returnFee) || 0 : 0);

  const rentTotal = details.details ? details.details.totalRent : 0;
  const deposit = details.details ? details.details.deposit : 0;
  const grandTotal = rentTotal + deposit + totalDeliveryFees;

  return (
    <Card>
      <BlockStack gap={100}>
        <Text variant="headingLg">Resumen</Text>
        <Text
          variant="headingXs"
          style={{ color: "var(--p-color-text-secondary)" }}
        >
          {time
            ? `Renta por ${time.days} día${time.days > 1 ? "s" : ""}${
                time.hours
                  ? " y " + time.hours + " hora" + (time.hours > 1 ? "s" : "")
                  : ""
              }`
            : ""}
        </Text>
        <Divider />
        <InlineGrid columns={2}>
          <Text>Entrega</Text>
          <Text alignment="end">
            {details.fromDate
              ? formatDate(details.fromDate, details.fromHours)
              : "---"}
          </Text>
        </InlineGrid>
        <InlineGrid columns={2}>
          <Text>Devolución</Text>
          <Text alignment="end">
            {details.toDate
              ? formatDate(details.toDate, details.toHours)
              : "---"}
          </Text>
        </InlineGrid>
        <br />
        <InlineGrid columns={["twoThirds", "oneThird"]}>
          <Text>Tarifa Diaria</Text>
          <span className="editable_total">
            <Button
              icon={!details.details || EditIcon}
              disabled={!details.details}
              variant="plain"
              onClick={() => {
                editTotal({
                  activated: true,
                  key: "dailyPrice",
                  value: details.details.dailyPrice,
                  title: "Tarifa Diaria",
                });
              }}
            />
            <Text alignment="end">
              <span className="edit_total_button">
                {details.details
                  ? formatPrice(details.details.dailyPrice)
                  : "---"}
              </span>
            </Text>
          </span>
        </InlineGrid>
        {details.details && details.details.hoursExtra ? (
          <InlineGrid columns={["twoThirds", "oneThird"]}>
            <Text>Horas Extra</Text>
            <span className="editable_total">
              <Button
                icon={EditIcon}
                variant="plain"
                onClick={() => {
                  editTotal({
                    activated: true,
                    key: "hoursExtra",
                    value: details.details.hoursExtra,
                    title: "Horas Extra",
                  });
                }}
              />
              <Text alignment="end">
                {formatPrice(details.details.hoursExtra)}
              </Text>
            </span>
          </InlineGrid>
        ) : null}

        {/* Delivery fee */}
        {deliveryType === "delivery" && (
          <InlineGrid columns={["twoThirds", "oneThird"]}>
            <Text>Entrega a Domicilio</Text>
            <TextField
              value={String(deliveryFee)}
              onChange={(val) => onDeliveryFeeChange(parseFloat(val) || 0)}
              type="number"
              prefix="$"
              autoComplete="off"
            />
          </InlineGrid>
        )}

        {/* Return fee */}
        {returnType === "delivery" && (
          <InlineGrid columns={["twoThirds", "oneThird"]}>
            <Text>Recoger a Domicilio</Text>
            <TextField
              value={String(returnFee)}
              onChange={(val) => onReturnFeeChange(parseFloat(val) || 0)}
              type="number"
              prefix="$"
              autoComplete="off"
            />
          </InlineGrid>
        )}

        <InlineGrid columns={["twoThirds", "oneThird"]}>
          <Text variant="headingSm">Total Renta</Text>
          <span className="editable_total">
            <Button
              icon={!details.details || EditIcon}
              disabled={!details.details}
              variant="plain"
              onClick={() => {
                editTotal({
                  activated: true,
                  key: "totalRent",
                  value: details.details.totalRent,
                  title: "Total",
                });
              }}
            />
            <Text alignment="end" variant="headingSm">
              {details.details ? formatPrice(rentTotal + totalDeliveryFees) : "---"}
            </Text>
          </span>
        </InlineGrid>
        <InlineGrid columns={["twoThirds", "oneThird"]}>
          <Text>Depósito</Text>
          <span className="editable_total">
            <Button
              icon={!details.details || EditIcon}
              disabled={!details.details}
              variant="plain"
              onClick={() => {
                editTotal({
                  activated: true,
                  key: "deposit",
                  value: details.details.deposit,
                  title: "Depósito",
                });
              }}
            />
            <Text alignment="end">
              {details.details ? formatPrice(deposit) : "---"}
            </Text>
          </span>
        </InlineGrid>
        <Divider />
        <InlineGrid columns={["twoThirds", "oneThird"]}>
          <Text variant="headingSm">Total</Text>
          <Text alignment="end" variant="headingSm">
            {details.details ? formatPrice(grandTotal) : "---"}
          </Text>
        </InlineGrid>
      </BlockStack>
    </Card>
  );
}

export default CreateReservationSummary;
